module.exports = __webpack_public_path__ + "static/media/childSupport.e477f112.png";